import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';

import { RequestContext } from '../../context/Request.context';
import { BaseButtonFill } from '..';
import { HalfPageLayout } from '../HalfPageLayout/HalfPageLayout';

import './ThankYouPage.scss';

const ThankYouContent = ({ t, link, description }) => (
  <div className="thank-you__wrapper">
    <h1 className="heading heading--primary">{t('request.thankYou.heading')}</h1>
    {description && <p className="copy copy--color-dark thank-you__description">{description}</p>}

    <BaseButtonFill
      onClick={() => (window.location = link)}
      iconRight
      icon="arrow-right"
      data-testid="thank-you-button"
    >
      {t('request.thankYou.button')}
    </BaseButtonFill>
  </div>
);

export const ThankYouPage = ({ link, description, isAdvisor }) => {
  const { t } = useTranslation();
  const { setSubmittedState } = useContext(RequestContext);

  useEffect(() => {
    window.scrollTo(0, 0);
    return () => {
      setSubmittedState(false);
    };
  }, [setSubmittedState]);

  return (
    <div
      className={classnames('thank-you', {
        'thank-you--advisor': isAdvisor,
      })}
      data-testid="thank-you"
    >
      <HalfPageLayout rightContent={<ThankYouContent t={t} link={link} description={description} />} />
    </div>
  );
};

export default ThankYouPage;
